import { connectInstructions } from "../../util/redux";
import OneBackInstructionsComponent from "../../components/one-back/instructions";

const OneBackInstructions = connectInstructions(OneBackInstructionsComponent);

export default OneBackInstructions;
